export function omit<T extends {}>(
  keys: string | string[],
  obj: T
): Record<string, unknown> | T {
  return Array.isArray(keys)
    ? Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)))
    : Object.fromEntries(Object.entries(obj).filter(([k]) => k !== keys))
}
